module.exports = __webpack_public_path__ + "static/media/image-dental.ef63a3ce.png";